import { Box, Typography } from '@mui/material';

export type ParameterItemProps = {
    label: string;
    value: string;
    isLast?: boolean;
};

const normalizeValue = (value: string): string => {
    const lowerValue = value.toLowerCase().trim();
    if (lowerValue === 'true') {
        return 'Áno';
    }
    if (lowerValue === 'false') {
        return 'Nie';
    }
    return value;
};

const ParameterItem = ({ label, value, isLast = false }: ParameterItemProps) => {
    const normalizedValue = normalizeValue(value);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                paddingX: 3,
                paddingY: 1.5,
                borderBottom: isLast ? 0 : 1,
                borderColor: 'divider',
            }}
        >
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body1" fontWeight="medium" color="text.primary">
                {normalizedValue}
            </Typography>
        </Box>
    );
};

export default ParameterItem;

